<template>
  <div class="conversation-history-details" :class="{ selected: isCurrentConversation }" @click="goToConversation">
    <div class="conversation-name" :class="{ 'selected-text': isCurrentConversation }">
      {{ title }}
    </div>
    <div class="creation-date">
      {{ formatCreatedAt }}
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router/dist/vue-router';

import { calculatePassedTime } from '~/utils/date-utils';
import { Routes } from '~/constants/routes';
import { GetCurrentConversation } from '~/constants/getters';
import useConversations from '~/composables/useConversations';
import { useI18n } from 'vue-i18n';

export default {
  props: {
    conversation: {
      type: Object,
      default: () => {},
    },
  },

  setup(props) {
    const router = useRouter();
    const store = useStore();
    const { t } = useI18n();
    const { setConversationScope } = useConversations();

    const currentConversation = computed(() => store.getters[`conversationStore/${GetCurrentConversation}`]);
    const isCurrentConversation = computed(
      () => props.conversation.conversationId === currentConversation.value.conversationId,
    );
    const actualConversation = computed(() => props.conversation);
    const formatCreatedAt = computed(() => calculatePassedTime(actualConversation.value.timestamp));
    const title = computed(() => props.conversation.title || formatCreatedAt.value);
    const conversationName = computed(() => actualConversation.value.conversationId || t('conversation.conversation'));
    const goToConversation = () => {
      const breadcrumb = [];
      // reinitialise scope of the the next conversation
      setConversationScope({ isScoped: false, collection: {}, breadcrumb });
      router.push({ name: Routes.Conversation.name, params: { conversationId: props.conversation.conversationId } });
    };
    return {
      conversationName,
      formatCreatedAt,
      isCurrentConversation,
      goToConversation,
      title,
    };
  },
};
</script>

<style scoped lang="scss">
.conversation-history-details:hover {
  background-color: $bb-neutral-4;
}

.selected {
  background-color: $bb-neutral-1 !important;
}

.selected-text {
  color: $bb-neutral-0 !important;
}

.conversation-history-details {
  display: flex;
  flex-direction: column;
  transition: background-color 0.3s ease;
  cursor: pointer;
  padding: $bb-spacing-2 $bb-spacing-4;
  border-radius: 100px;
  background: $bb-neutral-6;
  margin-bottom: $bb-spacing-1;

  .conversation-name {
    @include bb-medium-text-styles('md');
    line-height: $bb-spacing-5;
    color: $bb-neutral-1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .creation-date {
    @include bb-medium-text-styles('xs');
    color: $bb-neutral-3;
  }
}
</style>
